var map = {
	"./hiragana/a.png": 34,
	"./hiragana/ba.png": 35,
	"./hiragana/be.png": 36,
	"./hiragana/bo.png": 37,
	"./hiragana/bu.png": 38,
	"./hiragana/chi.png": 39,
	"./hiragana/da.png": 40,
	"./hiragana/de.png": 41,
	"./hiragana/do.png": 42,
	"./hiragana/e.png": 43,
	"./hiragana/fu.png": 44,
	"./hiragana/ga.png": 45,
	"./hiragana/ge.png": 46,
	"./hiragana/gi.png": 47,
	"./hiragana/go.png": 48,
	"./hiragana/gu.png": 49,
	"./hiragana/ha.png": 50,
	"./hiragana/he.png": 51,
	"./hiragana/hi.png": 52,
	"./hiragana/ho.png": 53,
	"./hiragana/i.png": 54,
	"./hiragana/ji.png": 55,
	"./hiragana/ji2.png": 56,
	"./hiragana/ka.png": 57,
	"./hiragana/ke.png": 58,
	"./hiragana/ki.png": 59,
	"./hiragana/ko.png": 60,
	"./hiragana/ku.png": 61,
	"./hiragana/ma.png": 62,
	"./hiragana/me.png": 63,
	"./hiragana/mi.png": 64,
	"./hiragana/mo.png": 65,
	"./hiragana/mu.png": 66,
	"./hiragana/n.png": 67,
	"./hiragana/na.png": 68,
	"./hiragana/ne.png": 69,
	"./hiragana/ni.png": 70,
	"./hiragana/no.png": 71,
	"./hiragana/nu.png": 72,
	"./hiragana/o.png": 73,
	"./hiragana/pa.png": 74,
	"./hiragana/pe.png": 75,
	"./hiragana/pi.png": 76,
	"./hiragana/po.png": 77,
	"./hiragana/pu.png": 78,
	"./hiragana/ra.png": 79,
	"./hiragana/re.png": 80,
	"./hiragana/ri.png": 81,
	"./hiragana/ro.png": 82,
	"./hiragana/ru.png": 83,
	"./hiragana/sa.png": 84,
	"./hiragana/se.png": 85,
	"./hiragana/shi.png": 86,
	"./hiragana/so.png": 87,
	"./hiragana/su.png": 88,
	"./hiragana/ta.png": 89,
	"./hiragana/te.png": 90,
	"./hiragana/to.png": 91,
	"./hiragana/tsu.png": 92,
	"./hiragana/u.png": 93,
	"./hiragana/wa.png": 94,
	"./hiragana/we.png": 95,
	"./hiragana/wi.png": 96,
	"./hiragana/wo.png": 97,
	"./hiragana/ya.png": 98,
	"./hiragana/yo.png": 99,
	"./hiragana/yu.png": 100,
	"./hiragana/za.png": 101,
	"./hiragana/ze.png": 102,
	"./hiragana/zo.png": 103,
	"./hiragana/zu.png": 104,
	"./hiragana/zu2.png": 105,
	"./katakana/a.png": 106,
	"./katakana/ba.png": 107,
	"./katakana/be.png": 108,
	"./katakana/bi.png": 109,
	"./katakana/bo.png": 110,
	"./katakana/bu.png": 111,
	"./katakana/chi.png": 112,
	"./katakana/da.png": 113,
	"./katakana/de.png": 114,
	"./katakana/do.png": 115,
	"./katakana/e.png": 116,
	"./katakana/fu.png": 117,
	"./katakana/ga.png": 118,
	"./katakana/ge.png": 119,
	"./katakana/gi.png": 120,
	"./katakana/go.png": 121,
	"./katakana/gu.png": 122,
	"./katakana/ha.png": 123,
	"./katakana/he.png": 124,
	"./katakana/hi.png": 125,
	"./katakana/ho.png": 126,
	"./katakana/i.png": 127,
	"./katakana/ji.png": 128,
	"./katakana/ji2.png": 129,
	"./katakana/ka.png": 130,
	"./katakana/ke.png": 131,
	"./katakana/ki.png": 132,
	"./katakana/ko.png": 133,
	"./katakana/ku.png": 134,
	"./katakana/ma.png": 135,
	"./katakana/me.png": 136,
	"./katakana/mi.png": 137,
	"./katakana/mo.png": 138,
	"./katakana/mu.png": 139,
	"./katakana/n.png": 140,
	"./katakana/na.png": 141,
	"./katakana/ne.png": 142,
	"./katakana/ni.png": 143,
	"./katakana/no.png": 144,
	"./katakana/nu.png": 145,
	"./katakana/o.png": 146,
	"./katakana/pa.png": 147,
	"./katakana/pe.png": 148,
	"./katakana/pi.png": 149,
	"./katakana/po.png": 150,
	"./katakana/pu.png": 151,
	"./katakana/ra.png": 152,
	"./katakana/re.png": 153,
	"./katakana/ri.png": 154,
	"./katakana/ro.png": 155,
	"./katakana/ru.png": 156,
	"./katakana/sa.png": 157,
	"./katakana/se.png": 158,
	"./katakana/shi.png": 159,
	"./katakana/so.png": 160,
	"./katakana/su.png": 161,
	"./katakana/ta.png": 162,
	"./katakana/te.png": 163,
	"./katakana/to.png": 164,
	"./katakana/tsu.png": 165,
	"./katakana/u.png": 166,
	"./katakana/wa.png": 167,
	"./katakana/wo.png": 168,
	"./katakana/ya.png": 169,
	"./katakana/yo.png": 170,
	"./katakana/yu.png": 171,
	"./katakana/za.png": 172,
	"./katakana/ze.png": 173,
	"./katakana/zo.png": 174,
	"./katakana/zu.png": 175,
	"./katakana/zu2.png": 176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;